module.exports = __webpack_public_path__ + "fepro/img/hr.3a846aba.png";